import { Checkbox } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';

declare module '@mui/system' {
    interface DefaultTheme extends Theme {}
}
export function CustomCheckbox({ children, ...props }: any) {
    return (
        <Checkbox
            sx={{
                color: 'dark',
                '&.Mui-checked': {
                    color: 'secondary',
                },
                marginLeft: -1,
            }}
            disableRipple
            // color='secondary'
            {...props}
            {...children}
        />
    );
}
